import React from "react";
import { Badge } from "@/components/ui/badge";
import {
  JobRequestStatus,
  JobRequestStatusColors,
  JobRequestStatusIcons,
  JobRequestStatusLabels,
} from "../../models/Jobs/JobRequestStatus";

interface JobRequestStatusChipProps {
  status: JobRequestStatus;
}

const JobRequestStatusChip: React.FC<JobRequestStatusChipProps> = ({ status }) => {
  const Icon = JobRequestStatusIcons[status];

  return (
    <Badge variant={JobRequestStatusColors[status]}>
      {Icon && <Icon className="size-3" />}
      {JobRequestStatusLabels[status]}
    </Badge>
  );
};

export default JobRequestStatusChip;
